export const BMTheme = JSON.parse(localStorage.getItem("theme"));



// WEBPACK FOOTER //
// ./src/BMTheme.js